import { MARKET_SLUG } from '~/src/constants/markets'
import {
  BLACK_MASS,
  LITHIUM_ION_BATTERIES,
} from '~/constants/services/constants'

export const isSpecialMarket = (market: string) =>
  market === MARKET_SLUG.RECYCLING ||
  market === MARKET_SLUG.LITHIUM_ION_BATTERIES ||
  market === LITHIUM_ION_BATTERIES.alternativeSlug

export const getMarketForRoute = (market: string) => {
  const MARKETS_SPECIALS = {
    [BLACK_MASS.slug]: MARKET_SLUG.RECYCLING,
    [MARKET_SLUG.LITHIUM_ION_BATTERIES]: LITHIUM_ION_BATTERIES.alternativeSlug,
  }
  return MARKETS_SPECIALS[market] || market
}

export const getPageForRoute = (market: string) => {
  const MARKETS_SPECIALS = {
    [BLACK_MASS.slug]: BLACK_MASS.slug,
    [LITHIUM_ION_BATTERIES.alternativeSlug]: MARKET_SLUG.LITHIUM_ION_BATTERIES,
  }
  return MARKETS_SPECIALS[market] || market
}
